import React from "react";
import { Logo } from "./ui";

export const legalLink = "font-bold text-[#0B2D4D] underline underline-offset-4 hover:text-slate-600";

export function Section({ title, children }) {
  return <section><h2 className="font-display text-2xl font-black text-[#0B2D4D]">{title}</h2><div className="mt-3 space-y-3">{children}</div></section>;
}

export function RetentionDetails() {
  return <>
    <p>El proceso actual no define un periodo adicional de retención de los datos de la cuenta enumerados aquí después de completar correctamente su eliminación.</p>
    <p>Por separado, los registros técnicos de límites de solicitudes por dirección IP, usados para prevenir abusos en el registro y la recuperación de acceso, no se borran con la cuenta. Su caducidad automática está configurada a las 24 horas de inactividad; la limpieza puede ejecutarse después de ese momento.</p>
    <p>La eliminación de la cuenta no ejecuta una eliminación de los registros de analítica de terceros. Para consultas sobre estos datos, escribe a <a className={legalLink} href="mailto:soporte@pawcita.com">soporte@pawcita.com</a>.</p>
  </>;
}

export default function LegalPage({ title, page, children }) {
  return <div className="min-h-screen bg-[#FBFCFF] text-[#0B2D4D]" data-testid={`${page}-screen`}>
    <header className="border-b border-slate-100 bg-white">
      <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-between gap-3 px-5 py-4 md:px-8">
        <a href="/" className={legalLink} data-testid={`${page}-back-home`}>← Volver al inicio</a><Logo size="sm" />
      </div>
    </header>
    <main className="mx-auto max-w-3xl px-5 pb-16 pt-10 md:px-8 md:pt-14">
      <p className="text-xs font-black uppercase tracking-[0.2em] text-slate-600">PawCita</p>
      <h1 className="mt-2 font-display text-4xl font-black leading-tight md:text-5xl">{title}</h1>
      <p className="mt-3 text-sm text-slate-500">Última actualización: 21 de septiembre de 2026</p>
      <div className="mt-8 space-y-8 text-base leading-relaxed text-slate-700">{children}</div>
      <nav aria-label="Información legal" className="mt-10 flex flex-wrap gap-5 border-t border-slate-200 pt-6 text-sm">
        <a href="/" className={legalLink}>Inicio</a>
        <a href="/privacy" className={legalLink}>Privacidad</a>
        <a href="/delete-account" className={legalLink}>Eliminar cuenta</a>
        <a href="/terms" className={legalLink}>Términos de Uso</a>
      </nav>
    </main>
  </div>;
}
